module.exports = __webpack_public_path__ + "img/hr-red-desert-bush-09.ba97a18f.png";